import baseDayjs from "dayjs";

import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

baseDayjs.extend(isSameOrAfter).extend(isSameOrBefore);

export const dayjs = baseDayjs;
